import { LOCALSTORAGE_KEYS } from '@features/General'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ISearchEventsPayload } from '@app-store/slices/events/searchEvents'

interface TaskAction extends Action {
    payload: ISearchEventsPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.events.searchEvents

function* searchEventsSagaTask({ payload }: TaskAction) {
    try {
        const params: any = {
            ...payload.pagination,
            query: payload.query
        }
        if (payload.textSearch) {
            params.textSearch = payload.textSearch
        }
        const response = yield axios.get(`/search/events`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            localStorage.setItem(LOCALSTORAGE_KEYS.EVENT_LIST, JSON.stringify(response.result.data))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* searchEventsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, searchEventsSagaTask)
}

export default searchEventsSaga
